/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NutritionWaterBalanceAliases {
  CONTEXTUAL_BAR_WATER_BALANCE = 'contextual-bar-water-balance',
  FIELD_BODY_SURFACE_AREA_M2 = 'field-body-surface-area-m2',
  FIELD_CALORIC_WEIGHT_KCAL = 'field-caloric-weight-kcal',
  FIELD_DURATION = 'field-duration',
  FIELD_HEIGHT = 'field-height',
  FIELD_JUSTIFICATION = 'field-justification',
  FIELD_MAXIMUM_DAILY_LIQUID_VOLUME_ML = 'field-maximum-daily-liquid-volume-ml',
  FIELD_MAXIMUM_DIET_VOLUME = 'field-maximum-diet-volume',
  FIELD_MAXIMUM_TOTAL_DAILY_VOLUME_ML = 'field-maximum-total-daily-volume-ml',
  FIELD_MAXIMUM_TOTAL_DIET_VOLUME_ML = 'field-maximum-total-diet-volume-ml',
  FIELD_MAXIMUM_VOLUME_OF_OTHER_ITEMS_ML = 'field-maximum-volume-of-other-items-ml',
  FIELD_MAXUMUM_DAILY_VOLUME = 'field-maxumum-daily-volume',
  FIELD_NUTRITION = 'field-nutrition',
  FIELD_PRESCRIBER_DATE = 'field-prescriber-date',
  FIELD_PRESCRIBER_NAME = 'field-prescriber-name',
  FIELD_START_DATE = 'field-start-date',
  FIELD_TOTAL_VOLUME_OF_OTHER_ITEMS_ML = 'field-total-volume-of-other-items-ml',
  FIELD_UNIT_MEASUREMENT_MAXIMUM_DIET_VOLUME = 'field-unit-measurement-maximum-diet-volume',
  FIELD_UNIT_MEASUREMENT_MAXIMUM_VOLUME_OF_OTHER_ITEMS_ML = 'field-unit-measurement-maximum-volume-of-other-items-ml',
  FIELD_UNIT_MEASUREMENT_MAXUMUM_DAILY_VOLUME = 'field-unit-measurement-maxumum-daily-volume',
  FIELD_WEIGHT = 'field-weight',
  FIELD_WEIGHT_KG = 'field-weight-kg',
  FORM_ADDITIONAL_INFORMATION = 'form-additional-information',
  FORM_MAIN_INFORMATIONS = 'form-main-informations',
  FORM_PERIOD_OF_VALIDITY = 'form-period-of-validity',
  FRAGMENT_REFERENCE_BAR_HEADER = 'fragment-reference-bar-header',
  INPUT_START_DATE = 'input-start-date',
  LAYOUT_WATER_BALANCE = 'layout-water-balance',
  LOADER = 'loader',
  PANEL_CONTENT = 'panel-content',
  PANEL_LOADER = 'panel-loader',
  SECTION_ADDITIONAL_INFORMATION = 'section-additional-information',
  SECTION_MAIN_INFORMATIONS = 'section-main-informations',
  SECTION_PERIOD_OF_VALIDITY = 'section-period-of-validity',
  SUPPRESS_HEADING_MARGIN_ADDITIONAL_INFORMATION = 'suppress-heading-margin-additional-information',
  SUPPRESS_HEADING_MARGIN_MAIN_INFORMATIONS = 'suppress-heading-margin-main-informations',
  SUPPRESS_HEADING_MARGIN_PERIOD_OF_VALIDITY = 'suppress-heading-margin-period-of-validity',
  TEXT_BODY_SURFACE_AREA_M2 = 'text-body-surface-area-m2',
  TEXT_CALORIC_WEIGHT_KCAL = 'text-caloric-weight-kcal',
  TEXT_DURATION = 'text-duration',
  TEXT_HEIGHT = 'text-height',
  TEXT_JUSTIFICATION = 'text-justification',
  TEXT_MAXIMUM_DAILY_LIQUID_VOLUME_ML = 'text-maximum-daily-liquid-volume-ml',
  TEXT_MAXIMUM_DIET_VOLUME = 'text-maximum-diet-volume',
  TEXT_MAXIMUM_TOTAL_DAILY_VOLUME_ML = 'text-maximum-total-daily-volume-ml',
  TEXT_MAXIMUM_TOTAL_DIET_VOLUME_ML = 'text-maximum-total-diet-volume-ml',
  TEXT_MAXIMUM_VOLUME_OF_OTHER_ITEMS_ML = 'text-maximum-volume-of-other-items-ml',
  TEXT_MAXUMUM_DAILY_VOLUME = 'text-maxumum-daily-volume',
  TEXT_NUTRITION = 'text-nutrition',
  TEXT_PRESCRIBER_DATE = 'text-prescriber-date',
  TEXT_PRESCRIBER_NAME = 'text-prescriber-name',
  TEXT_TOTAL_VOLUME_OF_OTHER_ITEMS_ML = 'text-total-volume-of-other-items-ml',
  TEXT_UNIT_MEASUREMENT_MAXIMUM_DIET_VOLUME = 'text-unit-measurement-maximum-diet-volume',
  TEXT_UNIT_MEASUREMENT_MAXIMUM_VOLUME_OF_OTHER_ITEMS_ML = 'text-unit-measurement-maximum-volume-of-other-items-ml',
  TEXT_UNIT_MEASUREMENT_MAXUMUM_DAILY_VOLUME = 'text-unit-measurement-maxumum-daily-volume',
  TEXT_WEIGHT = 'text-weight',
  TEXT_WEIGHT_KG = 'text-weight-kg',
}
export { NutritionWaterBalanceAliases };
